import { Link } from 'react-router-dom';
import { Nav, NavItem } from 'reactstrap';
interface INavColumn {
  tabId: number;
  label: string;
  activeClass?: string;
  inactiveClass: string;
}
interface INavTabsProps {
  tabs: INavColumn[];
  onTabClick: (tabId: number) => void;
  activeTab: number;
}
const NavTabs = ({ tabs, onTabClick, activeTab }: INavTabsProps) => {
  return (
    <Nav tabs className="nav nav-tabs border-0 mb-4">
      <NavItem className="nav-item ">
        {tabs?.map((tab) => {
          return (
            <Link
              to={'#'}
              className={
                activeTab === tab?.tabId ? tab?.activeClass : tab?.inactiveClass
              }
              style={{ cursor: 'pointer' }}
              onClick={() => onTabClick(tab?.tabId)}
            >
              {tab?.label}
            </Link>
          );
        })}
      </NavItem>
    </Nav>
  );
};
export default NavTabs;
